'use strict';

var _slicedToArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var Types = require('./types');

var Utils = require('./utils');

var internals = {
  needsProtoHack: new Set([Types.set, Types.map, Types.weakSet, Types.weakMap])
};

module.exports = internals.clone = function (obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _seen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  var clone = internals.clone;
  var seen = _seen;

  if (options.shallow) {
    if (options.shallow !== true) {
      return internals.cloneWithShallow(obj, options);
    }

    clone = function clone(value) {
      return value;
    };
  } else {
    seen = seen || new Map();
    var lookup = seen.get(obj);

    if (lookup) {
      return lookup;
    }
  } // Built-in object types


  var baseProto = Types.getInternalProto(obj);

  if (baseProto === Types.buffer) {
    return Buffer && Buffer.from(obj); // $lab:coverage:ignore$
  }

  if (baseProto === Types.date) {
    return new Date(obj.getTime());
  }

  if (baseProto === Types.regex) {
    return new RegExp(obj);
  } // Generic objects


  var newObj = internals.base(obj, baseProto, options);

  if (newObj === obj) {
    return obj;
  }

  if (seen) {
    seen.set(obj, newObj); // Set seen, since obj could recurse
  }

  if (baseProto === Types.set) {
    var _iterator = _createForOfIteratorHelper(obj),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        newObj.add(clone(value, options, seen));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (baseProto === Types.map) {
    var _iterator2 = _createForOfIteratorHelper(obj),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            key = _step2$value[0],
            _value = _step2$value[1];

        newObj.set(key, clone(_value, options, seen));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  var keys = Utils.keys(obj, options);

  var _iterator3 = _createForOfIteratorHelper(keys),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _key = _step3.value;

      if (_key === '__proto__') {
        continue;
      }

      if (baseProto === Types.array && _key === 'length') {
        newObj.length = obj.length;
        continue;
      }

      var descriptor = Object.getOwnPropertyDescriptor(obj, _key);

      if (descriptor) {
        if (descriptor.get || descriptor.set) {
          Object.defineProperty(newObj, _key, descriptor);
        } else if (descriptor.enumerable) {
          newObj[_key] = clone(obj[_key], options, seen);
        } else {
          Object.defineProperty(newObj, _key, {
            enumerable: false,
            writable: true,
            configurable: true,
            value: clone(obj[_key], options, seen)
          });
        }
      } else {
        Object.defineProperty(newObj, _key, {
          enumerable: true,
          writable: true,
          configurable: true,
          value: clone(obj[_key], options, seen)
        });
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return newObj;
};

internals.cloneWithShallow = function (source, options) {
  var keys = options.shallow;
  options = Object.assign({}, options);
  options.shallow = false;
  var storage = Utils.store(source, keys); // Move shallow copy items to storage

  var copy = internals.clone(source, options); // Deep copy the rest

  Utils.restore(copy, source, storage); // Shallow copy the stored items and restore

  return copy;
};

internals.base = function (obj, baseProto, options) {
  if (baseProto === Types.array) {
    return [];
  }

  if (options.prototype === false) {
    // Defaults to true
    if (internals.needsProtoHack.has(baseProto)) {
      return new baseProto.constructor();
    }

    return {};
  }

  var proto = Object.getPrototypeOf(obj);

  if (proto && proto.isImmutable) {
    return obj;
  }

  if (internals.needsProtoHack.has(baseProto)) {
    var newObj = new proto.constructor();

    if (proto !== baseProto) {
      Object.setPrototypeOf(newObj, proto);
    }

    return newObj;
  }

  return Object.create(proto);
};